import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

let uri = process.env.REACT_APP_APOLLO_API_URL || 'https://service-transactional.dev.embrix.org/graphql';
if (window._env_ && window._env_.REACT_APP_APOLLO_API_URL) {
  uri = window._env_.REACT_APP_APOLLO_API_URL;
}

const client = new ApolloClient({
  // By default, this client will send queries to the
  //  `/graphql` endpoint on the same host
  // Pass the configuration option { uri: YOUR_GRAPHQL_API_URL } to the `HttpLink` to connect
  // to a different host
  link: new HttpLink({
    uri,
  }),
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions,
});

export default client;
